(function(angular){
	'use strict';
	
	angular
		.module('viewReitElementModule')
		.controller('viewReitElement', [
			'$scope',
			'$timeout',
			'globalConfig',
			'InvestorUpdateFactory',
			'ReitElementFactory',
			'urlFactory',
			ViewReitElementFunction
		]);
	
	function ViewReitElementFunction(
		$scope,
		$timeout,
		globalConfig,
		InvestorUpdateFactory,
		ReitElementFactory,
		urlFactory
	){
		var viewReitElement = this;

		viewReitElement.changeSelectedView = function(view) {
			viewReitElement.selectedView = view;
			if(viewReitElement.selectedView === 'map') {
				$scope.$broadcast('reitElementDiversificationMap:showMap');
			}
		};

		viewReitElement.$onInit = function() {
			viewReitElement.reitElementLoading = true;
			viewReitElement.updatesLoading = true;
			viewReitElement.selectedView = 'image';
			angular.extend(viewReitElement, globalConfig);

			if(angular.isDefined(viewReitElement.reitElementId)) {
				ReitElementFactory.getReitElement(viewReitElement.reitElementId).then(
					function(reitElement) {
						viewReitElement.reitElement = reitElement;
						viewReitElement.scatterplotArray = [reitElement];
						$timeout(function() {
							$scope.$broadcast('runLazyLoad');
						});
						viewReitElement.reitElementLoading = false;
					}
				);

				ReitElementFactory.getCapitalStackForElement(viewReitElement.reitElementId).then(
					function(capitalStack) {
						viewReitElement.capitalStack = capitalStack;
					}
				);

				InvestorUpdateFactory.getAssociatedUpdatesByReitElementId(viewReitElement.reitElementId).then(function(updates) {
					viewReitElement.associatedUpdates = updates;
					viewReitElement.updatesLoading = false;
				});
			}

			if(viewReitElement.market && viewReitElement.market.thumbnailUrl) {
				viewReitElement.market.thumbnailUrl = urlFactory.prependStaticUrl(viewReitElement.market.thumbnailUrl);
			}
		};
	}
})(window.angular);